import classNames from 'classnames';

const BaseContent = ({type, className, children, ...props}) => (
    <div className={classNames(`${type}-content`, className)} {...props}>
        {children}
    </div>
);

export default BaseContent;
